export const HEADER_TITLE = [
  { label: '', key: 'bookmarked' },
  { label: 'newsAndSocial.SENTIMENTS', key: 'newsTypeName' },
  { label: 'newsAndSocial.HEADLINE', key: 'title' },
  { label: 'newsAndSocial.EVENTS', key: 'newsCategoryName' },
  { label: 'newsAndSocial.SOURCE', key: 'newsSourceName' },
  { label: 'newsAndSocial.PUBLICATION_DATE', key: 'publicDate' },
]

export const TIME_PERIOD_LIST = {
  allTime: {
    title: 'newsAndSocial.ALL_TIME',
    value: 1,
  },
  past30Days: {
    title: 'newsAndSocial.PAST30DAYS',
    value: 2,
  },
  past90Days: {
    title: 'newsAndSocial.PAST90DAYS',
    value: 3,
  },
  past6Months: {
    title: 'newsAndSocial.PAST6MONTHS',
    value: 4,
  },
  past1Year: {
    title: 'newsAndSocial.PAST1YEAR',
    value: 5,
  },
  customDate: {
    title: 'newsAndSocial.CUSTOM_DATE',
    value: 6,
  },
}
